module.exports = __webpack_public_path__ + "static/media/growth.be8d626b.svg";